import axios from "axios";
import { CONST } from "../config/const";

// システム設定一覧
export async function getSystemConfig() {
  try {
    const path = "venderConfig";
    const response = await axios.get(CONST.apiUrl + path);
    const detail_data: {
      [key: string]: string;
    } = response.data;
    return detail_data;
  } catch (error) {
    return {};
    // logout();
  }
}

// システム設定編集
export async function putSystemConfig(key: string, value: string) {
  try {
    const path = "venderConfig";
    const bodys = {
      key,
      value,
    };
    const response = await axios.put(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    return {};
    // logout();
  }
}
